import React, { useCallback, useEffect, useState } from 'react';
import { AutoComplete, ConfigProvider, Input } from 'antd';
import { Link, useMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchSearchShopList } from '../modules/shop/actions/getListSearch';
import { map } from 'underscore';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

const debounce = (fn, delay) => {
    let timeout = null;
    return function () {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn(...arguments);
            clearTimeout(timeout);
        }, delay);
    };
};

export const Searchbar = connect((state) => ({
    point: state.shopState.order.point,
    productsSearch: state.shopState.productsSearch,
}))(({ dispatch, point, productsSearch, showOptions = true, ...rest }) => {
    const navigate = useNavigate();
    const { isFetching, response } = productsSearch;
    const [value, setValue] = useState('');
    const isIndex = useMatch('/');

    function onSearch(value) {
        dispatch(
            fetchSearchShopList({
                text: value,
                point: point.id,
                row: 25,
            })
        );
    }

    const options = [
        ...map(response?.data, (product) => ({
            key: product.id,
            label: (
                <Link
                    onClick={(e) => e.preventDefault()}
                    to={`/categories/${product.type.id}/products/${product.id}`}
                >
                    {product.name}
                </Link>
            ),
            value: product.name,
            link: `/categories/${product.type.id}/products/${product.id}`,
        })),
    ];

    function onSelect(link, item) {
        if (item.link) navigate(item.link);
    }

    const debouncedSearch = useCallback(debounce(onSearch, 500), [point]);

    useEffect(() => {
        if (isIndex) {
            setValue('');
        }
    }, [isIndex]);

    return (
        <ConfigProvider
            theme={{
                components: {
                    Input: {
                        colorBgContainer: '#F6F7F8',
                        borderRadius: 25,
                        borderRadiusLG: 25,
                        borderRadiusSM: 25,
                        paddingSM: 15,
                        colorFillAlter: '#F6F7F8',
                        colorTextPlaceholder: '#D6D5D7',
                        lineType: 'none',
                    },
                },
            }}
        >
            <AutoComplete
                defaultActiveFirstOption
                onSelect={onSelect}
                value={value}
                onChange={setValue}
                allowClear
                options={showOptions ? options : []}
                onSearch={debouncedSearch}
                className={'searchbar'}
                popupClassName={'searchbar-menu'}
                {...rest}
            >
                <Input
                    size="large"
                    placeholder={'Искать'}
                    suffix={
                        isFetching ? <LoadingOutlined /> : <SearchOutlined />
                    }
                />
            </AutoComplete>
        </ConfigProvider>
    );
});
